import React from 'react';
import { component } from './styles.module.scss';

const Footer = (props) => {
  return (
    <footer className={component}>
      <nav className='footer nav background-dark justify-content-center'>
        <a className='nav-link' href='https://www.reuters.com/'>
          Reuters.com
        </a>
        <a className='nav-link' href='https://www.reuters.com/privacy-policy'>
          Privacy Policy
        </a>
        <a className='nav-link' href='https://www.reuters.com/terms-of-use'>
          Terms of Use
        </a>
      </nav>
    </footer>
  );
};

// console.log('%c \n' +
//             '                                                                                \n' +
//             '                                                                                \n' +
//             '                                                                                \n' +
//             '                                                                                \n' +
//             '                                                                                \n' +
//             '                              .       .;;.       .                              \n' +
//             "                            .;;,      .''.      ,;,                             \n" +
//             "                    .,'.     ..                 ..      .''.                    \n" +
//             '                   .:cc,                                ;cc:.                   \n' +
//             "                    ...           ...     ';'            ...                    \n" +
//             "            ,::;.           ..    ...     ',.   .:::.          ':::'            \n" +
//             "           .:ccc,          ...                  .,;,.  .''.    ;ccc;            \n" +
//             "            ....     .'.           .     .'..         'ccc:.    ...             \n" +
//             "      .','.          ..           'c;.   ;cc'  .;:,   .,;;'  ..      .','.      \n" +
//             "     .:cccc'    ..          .;.    .      ..   ;lll.       .:llc'   ,cccc:.     \n" +
//             "     .:ccc:'   .:c'              ..  .:c;. ';,. ... .clc;  'llll;   ,cccc:.     \n" +
//             "      ..'..     ..     ..        ;:' .,;, .cll. .'. ,lllc.  .','...  ....       \n" +
//             "   .''.      ..              ;,   . .'.  .. .. .ll,  ...  ..   ,cllc.   ..''.   \n" +
//             " .cllllc.  .:c:.    .           .:c..:' .'. .,     .''  .cll; .cllll:  .lllll:. \n" +
//             " ,llllll'   .,'    .,.   .'   ,;..'.           ..  .,'   ,::.  .;::,.  ;llllll. \n" +
//             "  ,:ll:'                     ..'.                     ..          .''. .,cll:'  \n" +
//             "   ..    .,:;'    .     .   ';.                   .   ',.  .::'  ;llll'   ...   \n" +
//             ".;cll:'  'ccc:.  ,c;       ..                      .       .,;.  'lllc.  ,cllc,.\n" +
//             'cllllll,  ....    .    .   ..                      .   ..          ..   ;llllll:\n' +
//             ":llllll'  .''.         ..  ..                      ,.       ...   .,,.  ,llllll;\n" +
//             " ';::,.  ,llll'  ,::.       .                     ..        ;:.  .cccc.  .;::;. \n" +
//             "   ....  'lllc.  ',,.  .;.   .                   .;.   .          .,,.   ....   \n" +
//             " .;llll;. ....                 .               .;'                     .:llll,  \n" +
//             " ,llllll,  'cll:.  ;ll;  .;;.  .  .         .;,.'.  .'    .;.   .;;'   ;llllll. \n" +
//             " .:llll:. .cllll:  ;ll;   .. ...  '. ',. ;c..;,  ..             .::,   .:llll;  \n" +
//             "   ....    .;cc;.      .,,.  :ll. ... .  ..  .   ,'                      ....   \n" +
//             "      .,,,.    .;:;'  .llll'  .. ,llc .:c:. ,:,        .     ...     .,,'.      \n" +
//             "     'ccccc,  .cllll.  ,::,. .,'  .'. .,,'        .          ,:;.   ;cccc:.     \n" +
//             "     .:ccc:.   .:c:,        'lll,  ....    ..    .'.                ':ccc:.     \n" +
//             "       ....         .;::;.   .,'   ,cc,   .::.          .'.          ....       \n" +
//             "            .','.   .:cc:.          ..                   ..    .','.            \n" +
//             '           .:ccc,    ...   .::;.                  .,.          ;ccc:            \n' +
//             "            .;;,.          .,;'   .;:,     ',.     .           .,;,.            \n" +
//             "                    .''.           .'.     ..           .''.                    \n" +
//             '                   .:cc,                                ;cc:.                   \n' +
//             '                    ...      ...                ...      ...                    \n' +
//             "                             ,;'      .,,.      ,;'                             \n" +
//             '                                      .;;.                                      \n' +
//             '                                                                                \n' +
//             '                                                                                \n' +
//             '                                                                                \n' +
//             '                           COVID-19 Global Tracker                \n' +
//             '                      Created with care @ReutersGraphics                            \n' +
//             '                 @GurmanBhatia • @Da_Pacific • @JonRMcClure                \n' +
//             '                                                                                \n' +
//             '                                                                                ',
// 'color:#FF8000;');

export default Footer;
